import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'verticalGuidesForTablo',
    standalone: false
})
export class VerticalGuidesForTabloPipe implements PipeTransform {
  transform(host: HTMLElement, scale: number): number[] {
    const hostBounding = host.getBoundingClientRect();
    return [
      hostBounding.x + hostBounding.width / 2,
      hostBounding.x + hostBounding.width / 4,
      hostBounding.x + (hostBounding.width / 4) * 3,
    ];
  }
}
